module.exports = __webpack_public_path__ + "media/images/lp_step2-06bcad41e5caf7da34021a716327338e.webp";